var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnGoogleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.886,
    height: 34.648,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#292a2a}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3538",
    "data-name": "\\uADF8\\uB8F9 3538",
    transform: "translate(-80.805 -5336.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1801",
    "data-name": "\\uC0AC\\uAC01\\uD615 1801",
    transform: "translate(80.805 5336.36)",
    style: {
      fill: "#fff",
      stroke: "#969696"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.886,
    height: 34.648,
    rx: 17.324,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92.886,
    height: 33.648,
    rx: 16.824,
    style: {
      fill: "none"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3286",
    "data-name": "\\uADF8\\uB8F9 3286",
    transform: "translate(96.453 5345.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1447",
    "data-name": "\\uD328\\uC2A4 1447",
    className: "cls-2",
    d: "M72.542 53.961a2.029 2.029 0 1 0 2.035 2.03 2 2 0 0 0-2.035-2.03m0 3.258a1.232 1.232 0 1 1 1.143-1.228 1.174 1.174 0 0 1-1.143 1.228zM68.1 53.961a2.029 2.029 0 1 0 2.036 2.03 2 2 0 0 0-2.036-2.03zm0 3.258a1.232 1.232 0 1 1 1.145-1.228 1.174 1.174 0 0 1-1.145 1.228zm-5.286-2.635v.86h2.06a1.8 1.8 0 0 1-.468 1.084 2.113 2.113 0 0 1-1.592.63 2.29 2.29 0 0 1 0-4.58 2.2 2.2 0 0 1 1.554.615l.607-.607a3 3 0 0 0-2.161-.869 3.151 3.151 0 1 0 0 6.3 2.881 2.881 0 0 0 2.2-.884 2.849 2.849 0 0 0 .746-2.014 2.8 2.8 0 0 0-.046-.538zm21.613.669a1.886 1.886 0 0 0-1.736-1.291 1.928 1.928 0 0 0-1.914 2.03 1.985 1.985 0 0 0 2.013 2.028 2.019 2.019 0 0 0 1.691-.9l-.692-.462a1.156 1.156 0 0 1-1 .561 1.034 1.034 0 0 1-.984-.613l2.714-1.122zm-2.767.677a1.113 1.113 0 0 1 1.061-1.183.783.783 0 0 1 .752.43zm-2.2 1.967h.891v-5.964h-.891zm-1.461-3.48h-.031a1.4 1.4 0 0 0-1.068-.454 2.031 2.031 0 0 0 0 4.058 1.377 1.377 0 0 0 1.068-.462h.031v.292c0 .777-.415 1.192-1.083 1.192a1.121 1.121 0 0 1-1.023-.723l-.776.323a1.931 1.931 0 0 0 1.8 1.2 1.854 1.854 0 0 0 1.928-2.113v-3.645H78zm-1.022 2.8a1.233 1.233 0 0 1 0-2.458 1.239 1.239 0 0 1 0 2.458zM88.6 51.933h-2.131V57.9h.889v-2.263H88.6a1.855 1.855 0 1 0 0-3.7zm.023 2.875h-1.265v-2.045h1.267a1.023 1.023 0 1 1 0 2.045zm5.5-.857a1.674 1.674 0 0 0-1.588.912l.79.331a.841.841 0 0 1 .813-.437.858.858 0 0 1 .936.768v.06a1.963 1.963 0 0 0-.929-.23c-.851 0-1.717.468-1.717 1.343a1.376 1.376 0 0 0 1.48 1.312 1.255 1.255 0 0 0 1.134-.583h.031v.459h.859V55.6a1.635 1.635 0 0 0-1.806-1.649zm-.108 3.268c-.292 0-.7-.147-.7-.507 0-.46.507-.637.943-.637a1.593 1.593 0 0 1 .814.2 1.08 1.08 0 0 1-1.054.944zm5.048-3.138-1.02 2.585h-.032l-1.059-2.585H96l1.59 3.613-.907 2.01h.929l2.448-5.623zM91.05 57.9h.889v-5.967h-.889z",
    transform: "translate(-37.087 -47.268)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3285",
    "data-name": "\\uADF8\\uB8F9 3285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1448",
    "data-name": "\\uD328\\uC2A4 1448",
    className: "cls-2",
    d: "m52.764 53.814-9.421-5.439a.871.871 0 0 0-.922.032l7.879 7.875z",
    transform: "translate(-42.008 -48.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1449",
    "data-name": "\\uD328\\uC2A4 1449",
    className: "cls-2",
    d: "M42.218 48.614a.869.869 0 0 0-.118.43v15.247c0 .051.031.09.039.139l7.948-7.947z",
    transform: "translate(-42.1 -48.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1450",
    "data-name": "\\uD328\\uC2A4 1450",
    className: "cls-2",
    d: "M42.276 63.029a.868.868 0 0 0 1.109.215l9.657-5.574-2.7-2.7z",
    transform: "translate(-42.05 -46.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1451",
    "data-name": "\\uD328\\uC2A4 1451",
    className: "cls-2",
    d: "m54.729 54.713-3.4-1.963-2.55 2.55 2.783 2.783 3.167-1.828a.891.891 0 0 0 0-1.542z",
    transform: "translate(-40.189 -46.973)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGoogleStore);
export default __webpack_public_path__ + "static/media/btn_google_store.d9d8b006.svg";
export { ForwardRef as ReactComponent };